import { IconProps } from "@/common/contracts/icon.contracts";

const Profile = ({ className }: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 13C9.35995 13 7.19995 11 7.19995 8.55556V7.44445C7.19995 5 9.35995 3 12 3C14.64 3 16.8 5 16.8 7.44445V8.55556C16.8 11 14.64 13 12 13Z"
        fill="currentColor"
      />
      <path
        d="M14.3805 15H9.61955C7.11413 15 5.01338 16.4916 4.12309 18.66C3.62081 19.884 4.73367 21 6.04887 21H17.9511C19.2663 21 20.3792 19.884 19.8769 18.66C18.9866 16.4916 16.8859 15 14.3805 15Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Profile;
